import { createRoutine } from 'redux-saga-routines';

import { IAsyncData } from '../../../models';
import { getInitialAsyncData } from '../../../utils';
import { MessageForm } from '../components/SendMessage';
import { EContactActions } from './enums';
import { getConfig, sendMessage } from './services';

export const ContactActions = Object.freeze({
    getConfig: () => ({
        type: EContactActions.GET_CONFIG,
        payload: getConfig(),
    }),

    sendMessage: (form: MessageForm) => ({
        type: EContactActions.SEND_MESSAGE,
        payload: sendMessage(form),
    }),

    sendMessageInitial: () => ({
        type: createRoutine(EContactActions.SEND_MESSAGE).TRIGGER,
        payload: getInitialAsyncData<IAsyncData<void>>(),
    }),
});
